import { MantineColor } from '@mantine/core';

export default {
	blue: [
		'#F4FAFF', '#E6F3FF', '#C3E1FF', '#98CEFF', '#5CB0FF',
		'#1C91FF', '#0271D7', '#00478A', '#002C55', '#212529'
	],
	space: [
		'#F8FBFF', '#E1ECFC', '#DAE2EE', '#9EB6D7', '#97A8BF',
		'#7386A0', '#546985', '#314662', '#1C2F46', '#061324'
	],
	dark: [
		'#C1C2C5', '#A6A7AB', '#909296', '#5C5F66', '#373A40',
		'#2C2E33', '#25262B', '#1A1B1E', '#141517', '#101113'
	],
	gray: [
		'#F8F9FA', '#F1F3F5', '#E9ECEF', '#DEE2E6', '#CED4DA',
		'#ADB5BD', '#868E96', '#495057', '#343A40', '#212529'
	],
	red: [
		'#FFF6F6', '#FFE9E9', '#F5C4C3', '#EB8888', '#E46160',
		'#DD3938', '#B12E2D', '#852222', '#581716', '#581716'
	],
	green: [
		'#F2FCF7', '#DDF7E8', '#B2E2C7', '#66C58E', '#33B169',
		'#009E43', '#007E36', '#005F28', '#003F1B', '#003F1B'
	],
	orange: [
		'#FFF7F2', '#FFECDF', '#FBD8BE', '#FDC295', '#F5A05F',
		'#F38837', '#C66820', '#94480F', '#613616', '#613616'
	],
	yellow: [
		'#FFFCF3', '#FFF6D9', '#F5E6B2', '#EBD37A', '#E6C241',
		'#DEAD00', '#B28A00', '#856800', '#594500', '#594500'
	],
	navy: [
		'#F0F5FF', '#CFDDFA', '#ABC6F9', '#5D8CE3', '#2863D2',
		'#204FA8', '#183B7E', '#102854', '#08142A', '#08142A'
	]
} as Partial<Record<MantineColor, string[]>>;
